module.exports = __webpack_public_path__ + "static/media/grey-circle.531939f2.svg";